import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQuery } from "../../baseQuery";

const locationApi = createApi({
  reducerPath: "locationApi",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    fetchLocations: builder.query<LocationSchema[], void>({
      query: () => "/api/fetch_locations",
      transformResponse: (response: { locations: LocationSchema[] }) => {
        return response.locations;
      },
    }),
  }),
});

export const { useFetchLocationsQuery } = locationApi;
export { locationApi };
